import React from 'react'
import "./../../UaeAttestation/UaeService/UaeService.css";
import AustriaBloreCertMain from './AustriaBloreCertMain';
import AustraliaBloreCertHead from '../../Australia/AustraliaBloreCert/AustraliaBloreCertHead';
const AustriaBloreCert = () => {
  return (
    <div className="uaeServiceContainer">
    <AustraliaBloreCertHead head="Austria Apostille service in Bangalore for certificates" />
    <AustriaBloreCertMain />
  </div>
  )
}

export default AustriaBloreCert
